module.exports = "/assets/data/1e6808e17c93c3b875501eb40d2ade9b-BS49.data.json";